import * as React from "react";
import { Icon } from "../icon/icon/icon.mjs";
const SortIndicator = (props) => {
  const { children, className, type, onClick } = props;
  const BEM = () => {
    const classArray = ["sort-indicator"];
    if (type) {
      classArray.push("sort-indicator--".concat(type));
    }
    if (className) {
      classArray.push(className);
    }
    return classArray.join(" ");
  };
  return /* @__PURE__ */ React.createElement("button", { onClick, className: BEM(), type: "button" }, /* @__PURE__ */ React.createElement("span", { className: "sort-indicator__text" }, children), /* @__PURE__ */ React.createElement("span", { className: "sort-indicator__arrows" }, /* @__PURE__ */ React.createElement(Icon, { modifiers: "#arrow-up", className: "sort-indicator__arrows-up" }), /* @__PURE__ */ React.createElement(Icon, { modifiers: "#arrow-down", className: "sort-indicator__arrows-down" })));
};
export {
  SortIndicator
};
